// @ts-nocheck
export default {
    SET_STORE_MANAGEMENT_FEE_BY_SECTION_DIALOG_OPEN(state, isOpen) {
        state.isStoreManagementFeeBySectionDialogOpen = isOpen;
    },
    SET_STORE_MANAGEMENT_FEE_BY_SECTION_ADD_FEE_SECTION_OPEN(state, isOpen) {
        state.isStoreManagementFeeBySectionAddFeeSectionOpen = isOpen;
    },
    SET_SELECTED_STORE_ID(state, storeId) {
        state.selectedStoreId = storeId;
    },
    SET_EDIT_FEE_ITEM(state, item) {
        state.editFeeItem = item;
    },
    POST_STORE_MANAGEMENT_FEE_BY_SECTION: (state, data) => {
        state.storeManagementFeeBySectionList = data;
    },
    GET_STORE_MANAGEMENT_FEE_BY_SECTION: (state, data) => {
        state.storeManagementFeeBySectionList = data;
    },
    PUT_STORE_MANAGEMENT_FEE_BY_SECTION: (state, data) => {
        const index = state.storeManagementFeeBySectionList.findIndex((fee) => fee.id === data.id);
        state.storeManagementFeeBySectionList[index] = data;
    },
    DELETE_STORE_MANAGEMENT_FEE_BY_SECTION: (state, data) => {
        state.storeManagementFeeBySectionList = data;
    },
    CLEAR_STORE_MANAGEMENT_FEE_BY_SECTION: (state) => {
        state.storeManagementFeeBySectionList = [];
    },
};
